export default __webpack_public_path__ + "static/media/CustomersMenuIcon.70fdb3f6.svg";